// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { List } from 'semantic-grab-ui/src';

import type { CampaignWarning, Nodes, NodeWarning, NodeOccMap } from 'types/trident-campaigns';
import { getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';

type Props = {
  warnings: CampaignWarning,
  nodes: Nodes,
  nodesOccMap: NodeOccMap,
};

// WarningChecklist display list of warning messages
export default class WarningChecklist extends Component {
  props: Props;

  getNodeName = (nodeID: string) => {
    const type = _.get(this.props.nodes, `${nodeID}.type`);
    let name = _.get(this.props.nodes, `${nodeID}.name`);
    if (_.isEmpty(name)) {
      name = getDefaultNodeName(nodeID, this.props.nodes[nodeID].type, this.props.nodesOccMap);
    }
    return `${type} node - ${name}`;
  };

  getNodeWarningsDisplay = (nodeID: string, warning: NodeWarning) => {
    const nodeName = this.getNodeName(nodeID);
    const warnings = [..._.get(warning, 'limits', [])];
    _.map(warning.data, messages => {
      warnings.push(...messages);
    });

    if (!_.isEmpty(warnings)) {
      return (
        <List.Item>
          <b>{nodeName}:</b>
          <List.List>
            {
              _.map(warnings, (message, index) => {
                return (
                  <List.Item key={index}>
                    <List.Icon name="warning sign" color="yellow" />
                    <List.Content>{message}</List.Content>
                  </List.Item>
                );
              })
            }
          </List.List>
        </List.Item>
      );
    }
  };

  render() {
    return (
      <List>
        {
          _.map(_.get(this.props.warnings, 'overall', []), message => {
            return (
              <List.Item>
                <List.Icon name="warning sign" color="yellow" />
                <List.Content>{message}</List.Content>
              </List.Item>
            );
          })
        }
        {
          _.isEmpty(_.get(this.props.warnings, 'overall')) &&
          <List.Item>
            <List.Icon name="smile" color="green" />
            <List.Content>Overall Good</List.Content>
          </List.Item>
        }
        {
          _.map(_.get(this.props.warnings, 'nodes', {}), (warning, nodeID) => {
            return this.getNodeWarningsDisplay(nodeID, warning);
          })
        }
      </List>
    );
  }
}
